<section class="container-style">
  <p-tabs value="0">
    <p-tablist class="sticky-tablist">
      <p-tab value="0"><i class="pi pi-desktop me-2"></i>Web</p-tab>
      @if (swAppMovil) {
      <p-tab value="1"><i class="pi pi-mobile me-2"></i>Móvil</p-tab>
      }
      <app-custom-button class="widthBtns" [label]="'Guardar'" [icon]="'pi pi-pen-to-square'" [severity]="'primary'"
        [variant]="undefined" [width]="'7rem'" [disabled]="disabledForm" (onClick)="savePermissions()">
      </app-custom-button>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <ng-container *ngTemplateOutlet="moduleList; context: { $implicit: webModules }"></ng-container>
      </p-tabpanel>
      @if (swAppMovil) {
      <p-tabpanel value="1">
        <ng-container *ngTemplateOutlet="moduleList; context: { $implicit: appModules }"></ng-container>
      </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</section>

<ng-template #moduleList let-modules>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-1">
    <p-accordion>
      <div class="row">
        @for (module of modules; track module.moduleId) {
        <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
          <p-accordion-panel [value]="module.moduleId">
            <p-accordion-header>
              <div class="d-flex flex-column">
                <div class="header-card-module d-flex gap-2">
                  <span class="header-card"> {{ module.name }}</span>
                  <app-custom-tag [severity]="getTagModule(module)" [value]="getTagTextModule(module)"
                    [visibleLabel]="false">
                  </app-custom-tag>
                </div>
                <div class="subtitle-card">
                  <span class="subtitle-card"> {{ module.windows.length }} ventana(s)</span>
                </div>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <hr class="m-0">
              <div class="permission-module d-flex align-items-center justify-content-between py-1 px-3">
                <p class="my-2">{{ module.name }}</p>
                <div class="d-flex gap-2">
                  <app-custom-toggle-switch [checked]="modulesCompanyId.indexOf(module.moduleId) != -1"
                    [disabled]="disabledForm" (onChangeToggle)="changeModule(module.moduleId)">
                  </app-custom-toggle-switch>
                </div>
              </div>
              <hr class="m-0">
              @for (window of module.windows; track window.windowId) {
              <div class="permission-window d-flex align-items-center justify-content-between gap-4 px-3 ">
                <div class="d-flex-1">
                  <div class="d-flex align-items-center gap-2 py-2">
                    <span class="dot dot-primary"></span>
                    <span class="text-foreground font-medium truncate">{{ window.labelName }}</span>
                  </div>
                </div>
                <div class="d-flex gap-2 my-2">
                  <div class="field-toggle-switch">
                    <app-custom-toggle-switch [checked]="windowsCompanyId.indexOf(window.windowId) != -1"
                      [disabled]="disabledForm" (onChangeToggle)="changeWindow(window.windowId)">
                    </app-custom-toggle-switch>
                  </div>
                </div>
              </div>
              <hr class="m-0">
              }
            </p-accordion-content>
          </p-accordion-panel>
        </div>
        }
      </div>
    </p-accordion>
  </div>
</ng-template>